import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <section className="w-full max-w-2xl mx-auto px-4 py-16" data-id="element-92">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-93">
        {/* Es para ti */}
        <div className="bg-[#25F4EE]/5 border border-[#25F4EE]/20 p-6 rounded-2xl" data-id="element-94">
          <h3 className="text-xl font-bold text-[#25F4EE] mb-6" data-id="element-95">
            Es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-96">
            {['estás en EE.UU. y quieres vender en español', 'puedes publicar 1 video al día por 14 días', 'quieres un método simple, no una carrera universitaria'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-97">
                <Check className="w-5 h-5 text-[#25F4EE] shrink-0 mt-0.5" data-id="element-98" />
                <span className="text-gray-300 text-sm md:text-base" data-id="element-99">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* No es para ti */}
        <div className="bg-[#FE2C55]/5 border border-[#FE2C55]/20 p-6 rounded-2xl" data-id="element-100">
          <h3 className="text-xl font-bold text-[#FE2C55] mb-6" data-id="element-101">
            No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-102">
            {["buscas 'dinero seguro'", 'no quieres publicar nada en video', "quieres saltarte el proceso y 'encontrar el producto ganador' sin volumen"].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-103">
                <X className="w-5 h-5 text-[#FE2C55] shrink-0 mt-0.5" data-id="element-104" />
                <span className="text-gray-300 text-sm md:text-base" data-id="element-105">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </motion.div>
    </section>;
}